import { CodeBrowser } from "components/icons/generated";
import { Blueprint } from "types/generated";

import MetaInfoListItem from "./Item";

type MetaInfoBlueprintProps = {
  blueprint: Blueprint;
  isGeneratedByTemplate: boolean;
};

const MetaInfoBlueprint = ({ blueprint, isGeneratedByTemplate }: MetaInfoBlueprintProps) => {
  const tooltip = isGeneratedByTemplate
    ? `Stack created from template ${blueprint.name}`
    : `Stack created from blueprint ${blueprint.name}`;
  const linkUrl = isGeneratedByTemplate
    ? `/template/${blueprint.groupDetails.id}/version/${blueprint.id}`
    : `/blueprint/${blueprint.ulid}`;

  return (
    <MetaInfoListItem
      href={linkUrl}
      linkText={blueprint.name}
      icon={CodeBrowser}
      tooltip={tooltip}
      type="commit"
    />
  );
};

export default MetaInfoBlueprint;
